module.exports = __webpack_public_path__ + "img/hadassa.6b54a31b.jpg";